angular.module('core')
  .constant("domainNameMapping", { // mapping applied to the domain name
    "Algebra": "AL"
  })
  .constant("domainShortCodeMapping", { // mappings applied on the short code
    "NOBT": "NBT",
    "OAT": "OA",
    "NOF": "NF",
    "TNS": "NS",
    "RPR": "RP",
    "APRE": "APR"
  })
  .filter('domainShort', ['domainNameMapping', 'domainShortCodeMapping', function(nameMapping, codeMapping) {
    return function(domainName, ast) {
      if(_.isString(domainName)) {
        if (nameMapping.hasOwnProperty(domainName)) {
          return nameMapping[domainName];
        }
        var shortCode = domainName.replace(/[^A-Z]/g, "");
        if (shortCode.length > 0) {
          if (codeMapping.hasOwnProperty(shortCode)) {
            return codeMapping[shortCode];
          }
          return shortCode;
        }
      }

      return domainName;
    };
  }
]);
